var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "_search-wrapper" }, [
    _c("div", { staticClass: "_search" }, [
      _c("input", {
        staticClass: "el-input",
        attrs: { placeholder: _vm.placeholder },
        domProps: { value: _vm.currentValue },
        on: { input: _vm.handleInput },
      }),
      _c(
        "button",
        {
          staticClass: "button",
          on: {
            click: function ($event) {
              return _vm._search()
            },
          },
        },
        [
          _c("img", {
            attrs: {
              src: require("images/search.png"),
              width: "18",
              height: "18",
            },
          }),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }